<template>
  <div :class="classCompute">{{ displayNumber }}</div>
</template>

<script lang="ts">
export default {
  name: 'Badge',
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    number: {
      type: Number!,
      validator(value: Number) {
        return Number.isInteger(value);
      },
    },
  },
  computed: {
    displayNumber(): String {
      const numberString = this.number.toString();
      if (!Number.isInteger(this.number)) return '';
      if (this.number < 1) {
        return '0';
      }
      if (this.number < 100) {
        return numberString;
      }
      return '99+';
    },
    classCompute(): String[] {
      const variantClasses = {
        primary: 'badge-primary',
        subdued: 'badge-subdued',
      };
      const widthClass = this.number > 99 ? 'wide' : null;
      return ['badge', variantClasses[this.variant], 'badge-small', widthClass];
    },
  },
};
</script>

<style scoped lang="scss">
.badge {
  text-align: center;
  font-weight: 500;
}

.badge-primary {
  background-color: theme('colors.primary.DEFAULT');
  color: theme('colors.primary.subdued');
}

.badge-subdued {
  background-color: theme('colors.primary.subdued');
  color: theme('colors.primary.DEFAULT');
}

.badge-small {
  border-radius: 10px;
  min-height: 20px;
  max-height: 20px;
  min-width: 20px;
  max-width: 20px;
  line-height: 19px;
  font-size: 12px;
  &.wide {
    min-width: 33px;
    max-width: 33px;
  }
}

.badge-large {
  border-radius: 12px;
  min-height: 24px;
  max-height: 24px;
  min-width: 24px;
  max-width: 24px;
  line-height: 24px;
  font-size: 14px;
  &.wide {
    min-width: 40px;
    max-width: 40px;
  }
}
</style>
